import { ListElement } from '@components/std-components/SelectComponent'
import React, { FC } from 'react'
import * as css from './SelectListItem.css'

const SelectListItem: FC<ListElement> = ({ children }) => {
  return <div className={css['list-container']}>{children}</div>
}

export const SelectListItemColumn: FC<ListElement> = ({ children }) => {
  return <div className={css['list-container-column']}>{children}</div>
}

export default SelectListItem
